const state = {
  purchaseStats: {
    donutChartData: [
      {
        info: "Ratio de items reales/items teoricos",
        series: [3.4545, 5],
        labels: ["Items reales", "Items teoricos"],
        title: "Ratio de items"
      },
      {
        info: "Ratio de ordenes recibidas correctamente",
        series: [1, 0],
        labels: ["Correctas", "Incorrectas"],
        title: "Ratio de ordenes recibidas correctamente"
      }
    ],
    boxData: [
      {
        info: "Total ordenes de entrada",
        value: 4,
        title: "Ordenes de entrada"
      },
      {
        info: "Total de ordenes recibidas",
        value: 1,
        title: "Ordenes recibidas"
      },
      {
        info: "Total de ordenes pendientes",
        value: 3,
        title: "Ordenes pendientes"
      },
      {
        info: "Total de ordenes recibidas correctamente",
        value: 1,
        title: "Ordenes recibidas correctamente"
      },
      {
        info: "Total de ordenes recibidas incorrectamente",
        value: 0,
        title: "Ordenes recibidas incorrectamente"
      },
      {
        info: "Tiempo de espera medio para ordenes de entrada",
        value: "0:00:26",
        title: "Espera media ordenes de entrada"
      },
      {
        info: "Tiempo de espera maximo para ordenes de entrada",
        value: "0:00:26",
        title: "Espera maxima ordenes de entrada"
      }
    ],
    barChartData: [
      {
        info: "Numero de ordenes recibidas diariamente",
        x_axis: ["2021-01-12T00:00:00Z", "2021-01-13T00:00:00Z"],
        series: [
          {
            name: "Series name 1",
            type: "column",
            data: [3, 1]
          }
        ],
        title: "Ordenes diarias"
      },
      {
        info: "Numero de items reales por dia",
        x_axis: ["2021-01-12T00:00:00Z", "2021-01-13T00:00:00Z"],
        series: [
          {
            name: "Series name 1",
            type: "column",
            data: [1, 2]
          }
        ],
        title: "Items verificados diarios"
      }
    ],
    timeChartData: [
      {
        info: "porders_daily_orders_info",
        series: [
          {
            type: "column",
            data: [3, 1],
            name: "porders_daily_orders_name"
          }
        ],
        x_axis: ["2021-01-12", "2021-01-13"],
        title: "porders_daily_orders_title"
      },
      {
        series: [
          {
            type: "column",
            data: [0, 0],
            name: "porders_daily_items_name"
          }
        ],
        x_axis: ["2021-01-12", "2021-01-13"],
        title: "porders_daily_items_title"
      }
    ],
    radialChart: [
      {
        info: "Ratio de items reales/items teoricos",
        series: [3.4545, 5],
        labels: ["Verified", "Theoritical"],
        title: "Ratio de items"
      }
    ]
  },
  entryStats: {
    donutChartData: [
      {
        info: "Ratio de items reales/items teoricos",
        series: [0, 5],
        labels: ["Items reales", "Items teoricos"],
        title: "Ratio de items"
      },
      {
        info: "Ratio de ordenes recibidas correctamente",
        series: [1, 0],
        labels: ["Correctas", "Incorrectas"],
        title: "Ratio de ordenes recibidas correctamente"
      }
    ],
    boxData: [
      {
        info: "Total ordenes de entrada",
        value: 4,
        title: "Ordenes de entrada"
      },
      {
        info: "Total de ordenes recibidas",
        value: 1,
        title: "Ordenes recibidas"
      },
      {
        info: "Total de ordenes pendientes",
        value: 3,
        title: "Ordenes pendientes"
      },
      {
        info: "Total de ordenes recibidas correctamente",
        value: 1,
        title: "Ordenes recibidas correctamente"
      },
      {
        info: "Total de ordenes recibidas incorrectamente",
        value: 0,
        title: "Ordenes recibidas incorrectamente"
      },
      {
        info: "Tiempo de espera medio para ordenes de entrada",
        value: "0:00:26",
        title: "Espera media ordenes de entrada"
      },
      {
        info: "Tiempo de espera maximo para ordenes de entrada",
        value: "0:00:26",
        title: "Espera maxima ordenes de entrada"
      }
    ],
    barChartData: [
      {
        info: "Numero de ordenes recibidas diariamente",
        x_axis: ["2021-01-12T00:00:00Z", "2021-01-13T00:00:00Z"],
        series: [
          {
            name: "Series name 1",
            type: "column",
            data: [3, 1]
          }
        ],
        title: "Ordenes diarias"
      },
      {
        info: "Numero de items reales por dia",
        x_axis: ["2021-01-12T00:00:00Z", "2021-01-13T00:00:00Z"],
        series: [
          {
            name: "Series name 1",
            type: "column",
            data: [1, 2]
          }
        ],
        title: "Items verificados diarios"
      }
    ],
    timeChartData: [
      {
        info: "porders_daily_orders_info",
        series: [
          {
            type: "column",
            data: [3, 1],
            name: "porders_daily_orders_name"
          }
        ],
        x_axis: ["2021-01-12", "2021-01-13"],
        title: "porders_daily_orders_title"
      },
      {
        series: [
          {
            type: "column",
            data: [0, 0],
            name: "porders_daily_items_name"
          }
        ],
        x_axis: ["2021-01-12", "2021-01-13"],
        title: "porders_daily_items_title"
      }
    ]
  },
  exitStats: {
    donutChartData: [
      {
        info: "Ratio de items reales/items teoricos",
        series: [0, 5],
        labels: ["Items reales", "Items teoricos"],
        title: "Ratio de items"
      },
      {
        info: "Ratio de ordenes recibidas correctamente",
        series: [1, 0],
        labels: ["Correctas", "Incorrectas"],
        title: "Ratio de ordenes recibidas correctamente"
      }
    ],
    boxData: [
      {
        info: "Total ordenes de entrada",
        value: 4,
        title: "Ordenes de entrada"
      },
      {
        info: "Total de ordenes recibidas",
        value: 1,
        title: "Ordenes recibidas"
      },
      {
        info: "Total de ordenes pendientes",
        value: 3,
        title: "Ordenes pendientes"
      },
      {
        info: "Total de ordenes recibidas correctamente",
        value: 1,
        title: "Ordenes recibidas correctamente"
      },
      {
        info: "Total de ordenes recibidas incorrectamente",
        value: 0,
        title: "Ordenes recibidas incorrectamente"
      },
      {
        info: "Tiempo de espera medio para ordenes de entrada",
        value: "0:00:26",
        title: "Espera media ordenes de entrada"
      },
      {
        info: "Tiempo de espera maximo para ordenes de entrada",
        value: "0:00:26",
        title: "Espera maxima ordenes de entrada"
      }
    ],
    barChartData: [
      {
        info: "Numero de ordenes recibidas diariamente",
        x_axis: ["2021-01-12T00:00:00Z", "2021-01-13T00:00:00Z"],
        series: [
          {
            name: "Series name 1",
            type: "column",
            data: [3, 1]
          }
        ],
        title: "Ordenes diarias"
      },
      {
        info: "Numero de items reales por dia",
        x_axis: ["2021-01-12T00:00:00Z", "2021-01-13T00:00:00Z"],
        series: [
          {
            name: "Series name 1",
            type: "column",
            data: [1, 2]
          }
        ],
        title: "Items verificados diarios"
      }
    ],
    timeChartData: [
      {
        info: "porders_daily_orders_info",
        series: [
          {
            type: "column",
            data: [3, 1],
            name: "entry_morders_max_time_title"
          }
        ],
        x_axis: ["2021-01-12", "2021-01-13"],
        title: "porders_daily_orders_title"
      },
      {
        series: [
          {
            type: "column",
            data: [0, 0],
            name: "entry_morders_max_time_title"
          }
        ],
        x_axis: ["2021-01-12", "2021-01-13"],
        title: "porders_daily_items_title"
      }
    ]
  },
  saleStats: {
    donutChartData: [
      {
        info: "Ratio de items reales/items teoricos",
        series: [0, 5],
        labels: ["Items reales", "Items teoricos"],
        title: "Ratio de items"
      },
      {
        info: "Ratio de ordenes recibidas correctamente",
        series: [1, 0],
        labels: ["Correctas", "Incorrectas"],
        title: "Ratio de ordenes recibidas correctamente"
      }
    ],
    boxData: [
      {
        info: "Total ordenes de entrada",
        value: 4,
        title: "Ordenes de entrada"
      },
      {
        info: "Total de ordenes recibidas",
        value: 1,
        title: "Ordenes recibidas"
      },
      {
        info: "Total de ordenes pendientes",
        value: 3,
        title: "Ordenes pendientes"
      },
      {
        info: "Total de ordenes recibidas correctamente",
        value: 1,
        title: "Ordenes recibidas correctamente"
      },
      {
        info: "Total de ordenes recibidas incorrectamente",
        value: 0,
        title: "Ordenes recibidas incorrectamente"
      },
      {
        info: "Tiempo de espera medio para ordenes de entrada",
        value: "0:00:26",
        title: "Espera media ordenes de entrada"
      },
      {
        info: "Tiempo de espera maximo para ordenes de entrada",
        value: "0:00:26",
        title: "Espera maxima ordenes de entrada"
      }
    ],
    barChartData: [
      {
        info: "Numero de ordenes recibidas diariamente",
        x_axis: ["2021-01-12T00:00:00Z", "2021-01-13T00:00:00Z"],
        series: [
          {
            name: "Series name 1",
            type: "column",
            data: [3, 1]
          }
        ],
        title: "Ordenes diarias"
      },
      {
        info: "Numero de items reales por dia",
        x_axis: ["2021-01-12T00:00:00Z", "2021-01-13T00:00:00Z"],
        series: [
          {
            name: "Series name 1",
            type: "column",
            data: [1, 2]
          }
        ],
        title: "Items verificados diarios"
      }
    ],
    timeChartData: [
      {
        info: "porders_daily_orders_info",
        series: [
          {
            type: "column",
            data: [3, 1],
            name: "porders_daily_orders_name"
          }
        ],
        x_axis: ["2021-01-12", "2021-01-13"],
        title: "porders_daily_orders_title"
      },
      {
        series: [
          {
            type: "column",
            data: [0, 0],
            name: "porders_daily_items_name"
          }
        ],
        x_axis: ["2021-01-12", "2021-01-13"],
        title: "porders_daily_items_title"
      }
    ]
  },
  inventoriesStats: {
    timeChartData: [],
    donutChartData: [
      {
        info: "Units in inventory vs units in transit",
        series: [3113, 6039],
        labels: ["total_units_in_inventory", "total_units_in_transit"],
        title: "In inventory vs in transit"
      }
    ],
    boxData: [
      {
        info: "total_units_in_inventory_info",
        value: 32113,
        title: "total_units_in_inventory_title"
      },
      {
        info: "total_units_in_transit_info",
        value: 6039,
        title: "total_units_in_transit_title"
      },
      {
        info: "total_number_of_inventories_info",
        value: 2,
        title: "total_number_of_inventories"
      }
    ]
  },
  locationSelected: [],
  startDate: "",
  endDate: ""
};

const mutations = {
  setpurchaseStats: (state, payload) => {
    state.purchaseStats = payload;
  },
  setentryStats: (state, payload) => {
    state.entryStats = payload;
  },
  setexitStats: (state, payload) => {
    state.exitStats = payload;
  },
  setsaleStats: (state, payload) => {
    state.saleStats = payload;
  },
  setinventoriesStats: (state, payload) => {
    state.inventoriesStats = payload;
  },
  setlocationSelected: (state, payload) => {
    state.locationSelected = payload;
  },
  setstartDate: (state, payload) => {
    state.startDate = payload;
  },
  setendDate: (state, payload) => {
    state.endDate = payload;
  }
};

const actions = {
  setpurchaseStats({ commit }, data) {
    commit("setpurchaseStats", data);
  },
  setentryStats({ commit }, data) {
    commit("setentryStats", data);
  },
  setexitStats({ commit }, data) {
    commit("setexitStats", data);
  },
  setsaleStats({ commit }, data) {
    commit("setsaleStats", data);
  },
  setinventoriesStats({ commit }, data) {
    commit("setinventoriesStats", data);
  },
  setlocationSelected({ commit }, data) {
    commit("setlocationSelected", data);
  },
  setstartDate({ commit }, data) {
    commit("setstartDate", data);
  },
  setendDate({ commit }, data) {
    commit("setendDate", data);
  }
};

const getters = {
  purchaseStats: state => state.purchaseStats,
  entryStats: state => state.entryStats,
  exitStats: state => state.exitStats,
  saleStats: state => state.saleStats,
  inventoriesStats: state => state.inventoriesStats,
  locationSelected: state => state.locationSelected,
  startDate: state => state.startDate,
  endDate: state => state.endDate
};

export default {
  state,
  mutations,
  actions,
  getters
};
